// Module
var code = `{{#}}
<a
  class="nav"
  data-channel="ROUTE"
  data-event-prevent-default="true"
  data-page-id="{{pageId}}"
  data-text="{{title}}"
  data-end-route="true"
  href="{{href}}"
  >{{title}}</a
>
{{/}}

<!-- Light/Dark Toggle -->
<button
  id="theme-toggle"
  data-event-type="setting"
  data-settings-type="theme"
  data-settings-value="light"
  class="nav theme-toggle"
  aria-label="Toggle Theme"
>
  <!-- Google Material Symbols (Apache 2.0): dark_mode / light_mode, outlined 24dp. -->
  <!-- Shows the mode a click switches TO; state rules in header.scss key on data-settings-value. -->
  <svg class="icon-moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" aria-hidden="true">
    <path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z"/>
  </svg>
  <svg class="icon-sun" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" aria-hidden="true">
    <path d="M565-395q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35Zm-226.5 56.5Q280-397 280-480t58.5-141.5Q397-680 480-680t141.5 58.5Q680-563 680-480t-58.5 141.5Q563-280 480-280t-141.5-58.5ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z"/>
  </svg>
</button>
`;
// Exports
module.exports = code;